import {VideoCaptionLanguage} from "./Video";
import {JsonAny} from "../../Types";
import parseISO from "date-fns/parseISO";

export interface VideoCaption {
    id: number;
    videoId: number;
    word: string;
    pronunciation: string;
    startMillis: number;
    endMillis: number;
    language: VideoCaptionLanguage;
    confidence: number;
    speaker: number;
    line: number;
    wordOrder: number;
    created: Date;
    transcript: string;
    sceneNumber: number;
    updated: Date;
}

export function parseVideoCaption(json: JsonAny): VideoCaption {
    return {
        ...json,
        created: parseISO(json.created)
    };
}
